import { render, staticRenderFns } from "./plain.vue?vue&type=template&id=15ba750e&"
var script = {}
import style0 from "./plain.vue?vue&type=style&index=0&id=15ba750e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports